import { render, staticRenderFns } from "./orderRedeemDetail.vue?vue&type=template&id=3c98a302&scoped=true&"
import script from "./orderRedeemDetail.vue?vue&type=script&lang=js&"
export * from "./orderRedeemDetail.vue?vue&type=script&lang=js&"
import style0 from "./orderRedeemDetail.vue?vue&type=style&index=0&id=3c98a302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c98a302",
  null
  
)

export default component.exports